export default __webpack_public_path__ + "static/media/slogan2.f199202f.png";